// extracted by mini-css-extract-plugin
export var ignore = "_6p-1";
export var mapping = "_6p-0";
export var range = "_6p-4";
export var savings = "_6p-3";
export var settings = "_6p-2";